import React from 'react';
import { useColorMode, useColorModeValue, IconButton } from '@chakra-ui/react';
import { FaMoon, FaSun, FaRegMoon } from 'react-icons/fa';
import { FiSun } from "react-icons/fi";

export const ColorModeSwitcher = props => {
  const { toggleColorMode } = useColorMode();
  const text = useColorModeValue('dark', 'light');
  const SwitchIcon = useColorModeValue(FaRegMoon, FiSun);
  // const SwitchIcon = useColorModeValue(FaMoon, FaSun);

  return (
    <IconButton
      size="md"
      fontSize="lg"
      aria-label={`Switch to ${text} mode`}
      variant="ghost"
      color="current"
      marginLeft="2"
      onClick={toggleColorMode}
      icon={<SwitchIcon />}
      {...props}
      aria-hidden='true'
      stroke-linejoin='round'

      _hover={{
        color: 'gray.500',
        transform: "scale(0.98)",
        transition: 'all .1s ease',
      }}
      _active={{
        color: 'gray.500',
        transform: "scale(0.96)",
        transition: 'all .1s ease',
      }}
    />
  );
};
